<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("expense.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="sessionStorage(search)"
                ></v-text-field>
              </v-col>
              <v-col cols="auto" class="d-flex align-center">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Year-Month"
                      readonly
                      v-bind="attrs"
                      outlined
                      dense
                      :style="{ maxWidth: '150px', height: '38px !important' }"
                      v-on="on"
                      clearable
                      class="pa-0 ma-0 mr-4"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" type="month" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        $refs.menu.save(date);
                        getExpenses();
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <router-link to="/societyadmin/expense/add" tag="button">
                  <v-btn class="primary">
                    <v-icon left> mdi-plus </v-icon>
                    Add Expense
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="notices"
            :search="search"
          >
              <template v-slot:item.title="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.title }}
                </div>
              </template>

              <template v-slot:item.note="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.note }}
                </div>
              </template>
              <template v-slot:item.amount="{ item }">
                ₹ {{ item.amount }}
              </template>

              <template v-slot:item.date="{ item }">
                {{ getFormattedDate(item.date) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="view_expense"
                  title="View Expense"
                  style="margin-left: -10px"
                  :to="'/societyadmin/expense/view/' + item.id"
                >
                  <img src="@/components/icons/view.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="edit_expense"
                  title="Edit expense"
                  :to="'/societyadmin/expense/edit/' + item.id"
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_expense"
                  title="Delete Expense"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>

              <template v-slot:footer.prepend="{}">
                <span class="grey--text font-weight-medium text-h6">Total Expenses : {{ total_expense }}</span>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2"> Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteExpense(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="deleteDialog = false">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  data() {
    return {
      search: "",
      // dropOptions: {
      // url: "https://httpbin.org/post"
      //  },
      headers: [
        {
          text: `${this.$t("expense.headers.title")}`,
          value: "title",
          width: "20%",
          align: "start",
        },
        {
          text: `${this.$t("expense.headers.note")}`,
          value: "note",
          width: "20%",
          align: "start",
          class: "text-truncate",
        },
        {
          text: `${this.$t("expense.headers.date")}`,
          value: "date",
          width: "15%",
          align: "start",
        },
        {
          text: `${this.$t("expense.headers.amount")}`,
          value: "amount",
          width: "15%",
          align: "start",
        },
        {
          text: `${this.$t("expense.headers.category")}`,
          value: "category.name",
          width: "15%",
          align: "start",
        },
        {
          text: `${this.$t("expense.headers.actions")}`,
          value: "actions",
          width: "15%",
          align: "start",
          sortable: false,
          date: "",
        },
      ],
      user: {},
      addPermissionDialog: false,
      deleteDialog: false,
      notices: [],
      delete_id: "",
      date: "",
      menu: "",
      total_expense: 0,
    };
  },
  watch: {
    date: function() {
      console.log(this.date);
      this.getExpenses();
    }
  },
  // components: {
  //   vueDropzone: vue2Dropzone
  // },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getExpenses() {
      var date = this.date;
      var split = date ? date.split("-") : null;
      let year = "0";
      let month = "0";
      if (date) {
        year = split[0];
        month = split[1];
      }
      let _self = this;
      _self.$axios
        .get("societyadmin/expenses?month=" + month + "&year=" + year)
        .then((response) => {
          let data = response.data;
          this.total_expense = data.total_expense;
          if (data.status) {
            _self.notices = data.expenses;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            if (data.type == "invalid") {
              localStorage.removeItem("user");
              _self.$router.push({ path: "/societyadmin/login" });
            }
          }
        });
    },
    deleteExpense(expenseId) {
      let _self = this;
      _self.$axios
        .delete("societyadmin/expenses/" + expenseId)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.notices.filter((record) => {
              if (record.id != expenseId) {
                return record;
              }
            });
            this.getExpenses();
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY") : "N/A";
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("expense_search");
      } else {
        sessionStorage.setItem("expense_search", search);
      }
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.getExpenses();
    this.search = sessionStorage.getItem("expense_search");
  },
};
</script>